import React from 'react';
import { createPortal } from 'react-dom';
import '../../styles/common/Modal.css';

const Modal = ({
  isOpen,
  onClose,
  children,
  overlayClassName = '',
  contentClassName = '',
  contentProps = {},
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = () => {
    onClose?.();
  };

  const combinedOverlayClass = ['modal-overlay', overlayClassName]
    .filter(Boolean)
    .join(' ');

  const mergedContentProps = {
    ...contentProps,
    className: ['modal-content', contentClassName, contentProps.className]
      .filter(Boolean)
      .join(' '),
    onClick: (event) => {
      event.stopPropagation();
      contentProps.onClick?.(event);
    },
  };

  return createPortal(
    <div className={combinedOverlayClass} onClick={handleOverlayClick}>
      <div {...mergedContentProps}>{children}</div>
    </div>,
    document.body
  );
};

export default Modal;
